import React from 'react';
import './OnboardingBanner.css';

const OnboardingBanner = ({ 
  step, 
  onAction, 
  onDismiss,
  site 
}) => {
  if (!step) return null;

  const getStepContent = () => {
    switch (step) {
      case 'create-site':
        return {
          icon: '🏗️',
          title: 'Welcome to The Ad Shop!',
          message: 'Get started by adding your first website. This will allow you to track analytics, revenue, and compliance.',
          actionText: 'Add Your First Site',
          actionType: 'primary'
        };
      
      case 'connect-ga4':
        return {
          icon: '📊',
          title: 'Connect Google Analytics',
          message: `Connect Google Analytics 4 to "${site?.name || 'your site'}" to start tracking traffic, users, and engagement metrics.`,
          actionText: 'Connect Google Analytics',
          actionType: 'primary'
        };
      
      case 'connect-adsense':
        return {
          icon: '💰',
          title: 'Connect AdSense (Optional)',
          message: `Connect Google AdSense to "${site?.name || 'your site'}" to track revenue and ad performance.`,
          actionText: 'Connect AdSense',
          actionType: 'secondary'
        };
      
      case 'connect-gsc':
        return {
          icon: '🔍',
          title: 'Connect Search Console (Optional)',
          message: `Connect Google Search Console to "${site?.name || 'your site'}" to track search performance and indexing.`,
          actionText: 'Connect Search Console',
          actionType: 'secondary'
        };
      
      default:
        return null;
    }
  };

  const content = getStepContent();
  if (!content) return null;

  return (
    <div className="onboarding-banner">
      <div className="onboarding-banner-content">
        <div className="onboarding-banner-icon">{content.icon}</div>
        <div className="onboarding-banner-text">
          <h3 className="onboarding-banner-title">{content.title}</h3>
          <p className="onboarding-banner-message">{content.message}</p>
        </div>
        <div className="onboarding-banner-actions">
          <button
            className={`onboarding-banner-button onboarding-banner-button-${content.actionType}`}
            onClick={onAction}
          >
            {content.actionText}
          </button>
          {onDismiss && (
            <button
              className="onboarding-banner-dismiss"
              onClick={onDismiss}
              aria-label="Dismiss"
            >
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingBanner;

